import { Box, Divider, Menu, MenuItem, useTheme } from '@mui/material'
import React from 'react'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Resolution } from '../../types'

interface Item {
  resolution: Resolution
  label: string
  onClick: () => void
}

interface ChartCsvExportButtonProps {
  menuAnchor: HTMLElement | null
  items: Array<Item>
  onClose: () => void
  onExport: (resolution: Resolution) => void
  isLoading: boolean
}

/**
 * Menu with resolution items to choose from. Resolution will be used to export the data in csv format (e.g. 15min, 1h, ...).
 */
const ExportMenu: React.FC<ChartCsvExportButtonProps> = ({ menuAnchor, items, onClose, onExport, isLoading }) => {
  const theme = useTheme()

  const handleOnClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, item: Item): void => {
    event.stopPropagation()
    item.onClick()
    onExport(item.resolution)
  }

  return (
    <Menu
      anchorEl={menuAnchor}
      open={!!menuAnchor}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ '& .MuiList-root': { p: 0 }, '& .MuiMenu-paper': { borderRadius: 2 } }}
    >
      <Box sx={{ pt: 2 }}>
        <Typography sx={{ px: 2, cursor: 'default' }} variant="subtitle2">
          {'csv-export.resolution.title'}
        </Typography>
        <Divider sx={{ borderColor: theme.palette.divider, pt: 2 }} />
      </Box>
      <Box sx={{ py: 2 }}>
        {items.map(item => (
          <MenuItem key={item.resolution} sx={{ py: 1, px: 2 }} onClick={event => handleOnClick(event, item)} disabled={isLoading}>
            <Typography variant="caption">{item.label}</Typography>
          </MenuItem>
        ))}
      </Box>
    </Menu>
  )
}

export default ExportMenu
